import React from 'react'

const SimpleView = () => {
  return (
    <div>SimpleView</div>
  )
}

export default SimpleView